import { useTranslation } from 'next-i18next';
import router from 'next/router';
import React, { useState } from 'react';
import toast from 'react-hot-toast';
import { useSignup } from '../../../../../hooks/useSignup';
import { SignupFormComponentInterface, UiComponentElementInterface } from '../../../../../interfaces/pagebuilder';
import { useSelector } from '../../../../../reduxToolkit/typedRedux';
import { resendTicket } from '../../../../../services/services';
import EmptyComponent from '../../../pageBuilder/EmptyComponent';
import { TicketCodeLogin } from '../../../signup/TicketCodeLogin';

const TicketcodeUiComponent = ({ uiComponent }: UiComponentElementInterface<SignupFormComponentInterface>) => {
  const { t } = useTranslation('pagebuilder');

  const registration = useSelector((state) => state.common.eventRegistration);
  const event = useSelector((state) => state.common.event);
  const { isPreviewModeOn } = useSignup(event);

  const [ticketcodeResendError, setTicketcodeResendError] = useState(false);

  async function resendTicketcode(email: string) {
    await resendTicket({ email, eventid: event?._id })
      .then(() => {
        setTicketcodeResendError(false);
        toast.success(t('auth:ticketcode-resend-success'));
      })
      .catch((e) => {
        if (e?.response?.data?.errorKey === 'TicketcodeResentRecentlyError') setTicketcodeResendError(true);
      });
  }

  return (
    <div
      className={`w-full grid place-items-center`}
      style={{
        color: uiComponent?.styling?.textColor || '#000',
      }}>
      {(!registration || isPreviewModeOn) && event ? (
        <div className="w-full max-w-[800px] min-w-[280px]">
          <TicketCodeLogin
            onSuccess={() => {
              toast.success(t('common:success'));
              return router.push(`/event/${event?.slug}`);
            }}
            onResendCode={(email) => resendTicketcode(email)}
            isError={ticketcodeResendError}
            component={uiComponent}
          />
        </div>
      ) : (
        <EmptyComponent componentName={t('pagebuilder:ticketcode-login')} />
      )}
    </div>
  );
};

export default TicketcodeUiComponent;
